import { Extracts } from '../components/fulfilment/index';
import NavigationBar from '../components/navigation/navigationBar';

const Reports: React.FC = () => {
  return (
    <div className="wrapper">
      <NavigationBar />
      <section className="container">
        <Extracts />
      </section>
    </div>
  );
}

export default Reports